export default __webpack_public_path__ + "static/media/KjuupPlus-Icon.8047bbc6.svg";